const Greeting = ({ welcomeMessage, name }) => (
  <div className="dashboard-greeting">
    <div className="dashboard-greeting__welcome">{welcomeMessage}</div>
    <div className="dashboard-greeting__name">{name}</div>
  </div>
);

export default Greeting;

